import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Clock, LogOut, Anchor } from 'lucide-react';
import { ThemeToggle } from '../components/ThemeToggle';
import { SUPPORT_EMAIL } from '../config/branding';

const PendingPage = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#f8fafc] flex items-center justify-center p-4 relative" style={{ fontFamily: 'Inter, sans-serif' }} data-testid="pending-page">
      <div className="absolute top-4 right-4">
        <ThemeToggle />
      </div>
      <div className="w-full max-w-sm space-y-6 text-center">

        {/* Logo */}
        <div className="flex items-center justify-center gap-2 mb-2">
          <div className="w-9 h-9 rounded-xl bg-navy-700 flex items-center justify-center">
            <Anchor className="w-5 h-5 text-white" strokeWidth={2} />
          </div>
          <span className="text-navy-900 font-bold text-base tracking-tight">RISQ Master Hub</span>
        </div>

        {/* Card */}
        <div className="bg-white border border-slate-200 shadow-sm rounded-2xl p-8">
          <div className="w-14 h-14 mx-auto mb-5 bg-amber-50 border border-amber-200 rounded-2xl flex items-center justify-center">
            <Clock className="w-7 h-7 text-amber-500" />
          </div>

          <h1 className="text-xl font-bold text-slate-900 mb-2" style={{ letterSpacing: '-0.02em' }} data-testid="pending-title">
            Account Under Review
          </h1>
          <p className="text-sm text-slate-500 mb-1">
            Welcome, <span className="font-semibold text-slate-700">{user?.name || user?.email}</span>
          </p>
          <p className="text-sm text-slate-400 mb-6 leading-relaxed">
            Your account has been flagged for review by the administrator. You'll receive access once it's approved.
          </p>

          <Button
            onClick={logout}
            variant="outline"
            className="w-full h-10 rounded-xl border-slate-200 text-slate-600 hover:bg-slate-50 text-sm font-medium"
            data-testid="pending-logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </div>

        <p className="text-xs text-slate-400">
          Questions? Email{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="text-navy-700 hover:underline">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </div>
  );
};

export default PendingPage;
